
  import { startGame } from './src/game.js';

  const canvas = document.getElementById('game');
  const $ = id => document.getElementById(id);

  const fmt = (s) => {
    s = Math.max(0, s);
    const m = Math.floor(s / 60), r = Math.floor(s % 60);
    return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
  };

  const hud = {
    setMessage(m) { $('center-msg').textContent = m || ''; },
    setPerspective(p) {
      $('perspective-label').textContent = p === 'HIDER' ? 'Hider · 3rd-person' : 'Seeker · 1st-person';
    },
    setSeekerState(s) { $('seeker-state').textContent = s; },
    setRoundProgress(t, won, lost) {
      const total = 90;
      $('round-progress').textContent = `${fmt(t * total)} / ${fmt(total)}`;
      $('round-w').textContent = won;
      $('round-l').textContent = lost;
    },
    setCaughtMeter(v) {
      $('caught-fill').style.width = `${Math.min(100, v * 100)}%`;
      $('caught-label').style.opacity = v > 0 ? 0.9 : 0.4;
      $('caught-label').textContent = v > 0.6 ? 'CAUGHT!' : v > 0.1 ? 'SEEN' : '· · ·';
    },
  };

  $('start-btn').addEventListener('click', async () => {
    const btn = $('start-btn');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Loading…';
    try {
      await startGame(canvas, hud);
      $('start').classList.add('hide');
      canvas.focus();
    } catch (e) {
      console.error('Failed to start game', e);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
